// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2EiN1Lq8E32FPksCwRvbbL"};